export default function useHeaderSearchFormVisibility() {
  const renderedHeaderSearchFormVisibility = useRenderedHeaderSearchFormVisibility()
  const stickyHeaderSearchFormShown = useStickyHeaderSearchFormShown()

  const isRenderedHeaderSearchFormVisibilityDynamic = computed(() => renderedHeaderSearchFormVisibility.value === 'dynamic')
  const isRenderedHeaderSearchFormVisibilityHidden = computed(() => renderedHeaderSearchFormVisibility.value === 'hidden')

  const isHeaderSearchFormInHeader = computed(() => renderedHeaderSearchFormVisibility.value !== 'hidden')

  const isHeaderSearchFormVisible = computed(() => {
    if (renderedHeaderSearchFormVisibility.value === 'hidden') {
      return false
    }

    if (isRenderedHeaderSearchFormVisibilityDynamic.value) {
      return stickyHeaderSearchFormShown.value
    }

    return true
  })

  return {
    isHeaderSearchFormInHeader,
    isHeaderSearchFormVisible,
    isRenderedHeaderSearchFormVisibilityDynamic,
    isRenderedHeaderSearchFormVisibilityHidden,
  }
}
